const myArticles = [];

export default myArticles;
